import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  onboardingFirstTimeUser,
  onboardingResetPasswordOtpRoute,
  onboardingSetPasswordRoute,
  onboardingResetPasswordUserIdRoute,
  onboardingBrokerLoginRoute,
  onboardingResetPasswordResendOtpRoute,
  onboardingBrokerRoute,
} from 'src/routing/routes';
import FirstTimeUserBrokerId from './first-time-user/first-time-user-broker';
import BrokerForgotPasswordOtp from './broker-otp/broker-forgot-password-otp';
import BrokerChangePassword from './change-password/broker-change-password';
import ForgotPasswordBrokerId from './forgot-password/forgot-password-broker-id';
import { CheckSalesOrg } from 'src/containers/onboarding/broker-login/check-sales_org/check_sales_org';
import ForgotBrokerPasswordResendOtp from './forgot-password-resend-otp/forgot-broker-password-resend-otp';
import Login from 'src/containers/onboarding/broker-login/login';
import TechnicalError from 'src/containers/self-service/technical-error/technical-error';
import { BrokerLoginProvider } from 'src/context/broker-login/broker-login-context';

export default function BrokerSelfService() {
  return (
    <TechnicalError fullPage>
      <BrokerLoginProvider>
        <Switch>
          <Route path={onboardingBrokerLoginRoute} component={Login} />
          <Route path={onboardingFirstTimeUser} component={FirstTimeUserBrokerId} />
          <Route
            path={onboardingResetPasswordResendOtpRoute}
            component={ForgotBrokerPasswordResendOtp}
          />
          <Route path={onboardingResetPasswordOtpRoute} component={BrokerForgotPasswordOtp} />
          <Route path={onboardingSetPasswordRoute} component={BrokerChangePassword} />
          <Route
            exact
            path={onboardingResetPasswordUserIdRoute}
            component={ForgotPasswordBrokerId}
          />
          <Route exact path={onboardingBrokerRoute} component={CheckSalesOrg} />
        </Switch>
      </BrokerLoginProvider>
    </TechnicalError>
  );
}
